import api from '../../api'

export const persist = async (contacts, localAccountId, contactTypes) => {

	for (const contact of contacts) {
		if (contact.readOnly) {
			continue
		}

		if (contact.isCreate) {
			let resp = await api.service('contacts').create({
				name: contact.contactPrimaryName,
				title: contact.contactTitle,
				email: contact.contactEmail,
				notifyWhenDispatched: contact.dispatchedNotification,
				notifyWhenRolling: contact.vehicleRollingNotification
			})

			const contactId = resp.id

			await api.service('localAccountsContacts').create({
				contactId: contactId,
				localAccountId: localAccountId
			})

			if (contact.contactPhoneNumber) {
				await api.service('contactNumbers').create({
					contactId: contactId,
					type: 'Mobile',
					number: contact.contactPhoneNumber,
					isSmsCapable: false
				})
			}

			for (const contactType of contact.contactTypes) {
				let contactTypeId = contactTypes.filter(c => c.name === contactType)[0].id

				await api.service('contactsContactTypes').create({
					contactId: contactId,
					contactTypeId: contactTypeId
				})
			}
		} 
		
		if (contact.isUpdate) {
			await api.service('contacts').patch(contact.id, {
				name: contact.contactPrimaryName,
				title: contact.contactTitle,
				email: contact.contactEmail,
				notifyWhenDispatched: contact.dispatchedNotification,
				notifyWhenRolling: contact.vehicleRollingNotification
			})

			await api.service('contactsContactTypes').remove(null, {
				query: {
					contactId: {
						$eq: contact.id
					},
				}
			})

			for (const contactType of contact.contactTypes) {
				let updateContactTypeId = contactTypes.filter(c => c.name === contactType)[0].id

				await api.service('contactsContactTypes').create({
					contactId: contact.id,
					contactTypeId: updateContactTypeId
				})
			}

			if (!contact.contactPhoneNumber) {
				await api.service('contactNumbers').remove(null, {
					query: {
						contactId: {
							$eq: contact.id
						},
					}
				})
			} else {
				let resp = await api.service('contactNumbers').find({
					query: {
						contactId: {
							$eq: contact.id
						}
					}
				})

				if (resp.data.length === 0) {
					await api.service('contactNumbers').create({
						contactId: contact.id,
						type: 'Mobile',
						number: contact.contactPhoneNumber,
						isSmsCapable: false
					})
				} else {
					await api.service('contactNumbers').patch(resp.data[0].id, {
						contactId: contact.id,
						type: 'Mobile',
						number: contact.contactPhoneNumber,
						isSmsCapable: false
					})
				}
			}
		}

		if (contact.isDelete) {
			await api.service('contactsContactTypes').remove(null, {
				query: {
					contactId: {
						$eq: contact.id
					},
				}
			})

			await api.service('contactNumbers').remove(null, {
				query: {
					contactId: {
						$eq: contact.id
					},
				}
			})

			await api.service('localAccountsContacts').remove(null, {
				query: {
					localAccountId: { $eq: localAccountId },
					contactId: { $eq: contact.id },
				}
			})

			await api.service('contacts').remove(null, {
				query: {
					id: { $eq: contact.id },
				}
			})
		}

	}
}


// WEBPACK FOOTER //
// ./src/database/lbb/contacts.js